<div class="aza-activities-cart aza-vertical-stack">
    <div class="aza-activities-cart-list-container">
        <aza-rws-activities-cart-list *ngIf="eventSettings" [eventSettings]="eventSettings"
            [searchTextChanged]="searchTextChanged" [showActivitiesCart]="showActivitiesCart"
            [activitiesCartFilterSubject]="activitiesCartFilterSubject" [activitiesCartFilterItemId]="selectedDisplayFilterItemId"
            [displayType]="activitiesCartDisplayType" [locked]="locked" [showAddToCalendar]="showAddToCalendar"
            [hideAvailablePlacesLeft]="hideAvailablePlacesLeft"
            (activitiesChanged)="onActivitiesChanged($event)">
        </aza-rws-activities-cart-list>
    </div>
</div>
